// src/index.ts
export * from "@react-spring/web";
//# sourceMappingURL=react-spring.legacy-esm.js.map